(function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));
 setTimeout(function(){

   function resetSlider(){
      setTimeout(function(){ 
       
jQuery('ul.swatch-view.swatch-view-image').eq(0).css('transform', 'matrix(1,0,0,1,0,0)');
    jQuery('ul.swatch-view.swatch-view-image').eq(1).css('transform', 'matrix(1,0,0,1,0,0)');
jQuery('ul.swatch-view.swatch-view-image').eq(2).css('transform', 'matrix(1,0,0,1,0,0)');
}, 1000);
    setTimeout(function(){ 
       
jQuery('ul.swatch-view.swatch-view-image').eq(0).css('transform', 'matrix(1,0,0,1,0,0)');
    jQuery('ul.swatch-view.swatch-view-image').eq(1).css('transform', 'matrix(1,0,0,1,0,0)');
jQuery('ul.swatch-view.swatch-view-image').eq(2).css('transform', 'matrix(1,0,0,1,0,0)');
}, 1500);
   }
var kk = 0; var timerkk = setInterval(function(){
  if($('variant-swatch-king ul.swatch-view').eq(0).length) {
//resetSlider()
    
 setTimeout(function(){ 
   var swatches = $('variant-swatch-king ul.swatch-view').slice(0,3).map(function(){return this.innerHTML}).get().join('');
    $('.upsell-box-inner').eq(0).html(swatches)
   $('.upsell-box-inner').eq(1).html(swatches)
   

    
    $(".product-upsell-selector .upsell-box-inner").eq(0).find('.star-set-image').each(function(){
      var swatchUrl = $(this).parent().attr('swatch-url');
      var firstPreviewImage = "";
      var setImage = $(this)
        if (swatchUrl) {
            $.getJSON(swatchUrl + '.js', function (data) {
                if (data && data.images.length > 0) {
                    var firstPreviewImage = data.images[0]; // First image in the images array
                    


                    var imgSrc = firstPreviewImage;
                    var variant = setImage.closest('li').attr('orig-value')
                  
                  // Append the image only if imgSrc is valid
                  if (imgSrc) {
                    $(".product-upsell-image")
                      .eq(0)
                      .append($('<img class="upsell-img" src="' + imgSrc + '" data-variant="'+variant+'">'));
                  }
                } else {
                    console.log('No images found.');
                }
            }).fail(function () {
                console.log('Failed to load product JSON.');
            });
        } else {
            console.log('No swatch-url attribute found.');
        }
     
     
    })


      $(".product-upsell-selector .upsell-box-inner").eq(1).find('.star-set-image').each(function(){
      var swatchUrl = $(this).parent().attr('swatch-url');
      var firstPreviewImage = "";
      var setImage = $(this)
        if (swatchUrl) {
            $.getJSON(swatchUrl + '.js', function (data) {
                if (data && data.images.length > 0) {
                    var firstPreviewImage = data.images[0]; // First image in the images array


                    var imgSrc = firstPreviewImage;
                    var variant = setImage.closest('li').attr('orig-value')
                  
                  // Append the image only if imgSrc is valid
                  if (imgSrc) {
                    $(".product-upsell-image")
                      .eq(1)
                      .append($('<img class="upsell-img" src="' + imgSrc + '" data-variant="'+variant+'">'));
                  }
                } else {
                    console.log('No images found.');
                }
            }).fail(function () {
                console.log('Failed to load product JSON.');
            });
        } else {
            console.log('No swatch-url attribute found.');
        }
     
     
    })
 $('.product-upsell-selector li:not(.swatch-item-unavailable)').click(function(){
      $(this).closest('.upsell-box-inner').find('li').removeClass('selected')
      $(this).addClass('selected');

      $(this).closest('.upsell-box').find('.upsell-img').removeClass('show-image');
      $(this).closest('.upsell-box').find('[data-variant="'+$(this).attr('orig-value')+'"]').addClass('show-image');


   $('.product-option-name span.option-title').eq(0).html($('.upsell-box-inner').eq(0).find('li.swatch-view-item.selected').eq(0).attr('orig-value'));
   $('.product-option-name span.option-title').eq(1).html($('.upsell-box-inner').eq(1).find('li.swatch-view-item.selected').eq(0).attr('orig-value'));
    }); 
   
 $(".product-upsell-selector .upsell-box-inner").eq(0).find('li:not([orig-value="-hide"]):not(.swatch-item-unavailable)').eq(0).click();
    $(".product-upsell-selector .upsell-box-inner").eq(1).find('li:not([orig-value="-hide"]):not(.swatch-item-unavailable)').eq(0).click();
     setTimeout(function(){ 
 $(".product-upsell-selector .upsell-box-inner").eq(0).find('li:not([orig-value="-hide"]):not(.swatch-item-unavailable)').eq(0).click();
    $(".product-upsell-selector .upsell-box-inner").eq(1).find('li:not([orig-value="-hide"]):not(.swatch-item-unavailable)').eq(0).click();
}, 500);
 setTimeout(function(){ 
 $(".product-upsell-selector .upsell-box-inner").eq(0).find('li:not([orig-value="-hide"]):not(.swatch-item-unavailable)').eq(0).click();
    $(".product-upsell-selector .upsell-box-inner").eq(1).find('li:not([orig-value="-hide"]):not(.swatch-item-unavailable)').eq(0).click();
}, 1000);
   


$('.upsell-atc').click(function(e){
async function addMultipleProductsToCart(productHandles) {
  try {
    const products = [];

    // Step 1: Fetch product details for each handle
    for (const handle of productHandles) {
      const productUrl = `${handle}.js`;
      const productResponse = await fetch(productUrl);

      if (!productResponse.ok) {
        throw new Error(`Failed to fetch details for product: ${handle}`);
      }

      const productData = await productResponse.json();
      const variantId = productData.variants[0].id; // Select the first variant by default

      // Add the product's variant and quantity to the array
      products.push({
        id: variantId,
        quantity: 1, // Set quantity for each product (adjust as needed)
      });
    }

    // Step 2: Add multiple products to the cart
    const cartResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: products }),
    });

    if (!cartResponse.ok) {
      throw new Error('Failed to add products to the cart');
    }

    const cartData = await cartResponse.json();
    console.log('Products added to cart:', cartData);
  } catch (error) {
    console.error('Error:', error.message);
  }
}
  var urlList = [];
  
  var swatchUrl = "/products/" + $("[data-product-handle]").attr('data-product-handle');
  var swatchUrl1 = $('.product-upsell-selector li.swatch-view-item.selected').eq(0).find('[swatch-url]').attr('swatch-url');
  var swatchUrl2 = $('.product-upsell-selector li.swatch-view-item.selected').eq(1).find('[swatch-url]').attr('swatch-url');

  

  urlList.push(swatchUrl);
  $('.addons-product-item.active').each(function(){
    urlList.push($(this).attr('data-handle'));
    
  })
  if($('input#pdp-upsell-toggle:checked').length){

    urlList.push(swatchUrl1);
    urlList.push(swatchUrl2);
  }
  
  
  // Example usage
  addMultipleProductsToCart(urlList);

// Example usage

  
}); 

     setInterval(function(){

       var curr = "$"

       if($('.product__price [data-price]').length){
         var price = ".product__price [data-price]";
       }
       else{
          var price = ".product__price";
       }

       
            var curPrice = parseFloat($(price).eq(0).text().substring(1).split(' ')[0].replaceAll(',', ''));
       console.log("cur: " + curPrice);
           var salePrice = curPrice;
           var comparePrice = curPrice;

       curr = $(price).eq(0).text().trim().charAt(0);



       if($('input#pdp-upsell-toggle:checked').length){
          
           var numberOfProducts = 2;
           var discount = 5;
           var curPrice = parseFloat($(price).eq(0).text().substring(1).split(' ')[0].replaceAll(',', ''));

         console.log("cur2: " + curPrice);
         
           var bundlePrice = (curPrice * numberOfProducts) - parseInt(jQuery('p.product-upsell-header-description .money').text().substring(1).split(' ')[0].replaceAll(',', ''));
         
           var bundleComparePrice = curPrice * numberOfProducts;

         console.log('b' + bundlePrice)
         salePrice += bundlePrice;
         comparePrice += bundleComparePrice;

         console.log('s' + salePrice)
         
       }

       if($('.addons-product-item').hasClass('active')){
         $('.addons-product-item.active').each(function(){
           var curPrice = parseFloat($(this).find('.addons-price-tag').eq(0).text().substring(1).split(' ')[0].replaceAll(',', ''));
           
           salePrice += curPrice;
           comparePrice += curPrice;
         })
         
       }

       

    
if(comparePrice <= salePrice){
  $('span.atc-comparePrice').hide();
}
       else{
           $('span.atc-comparePrice').show();
       }

    $('span.atc-salePrice').html(curr + salePrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
$('span.atc-comparePrice').html(curr + comparePrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));

}, 100);


   $('input#pdp-upsell-toggle').on('change', function() {
    
  if ($(this).is(':checked')) {
    $('.upsell-atc').addClass('active');
  } else if(!$('.addons-product-item').hasClass('active')){
    $('.upsell-atc').removeClass('active');
  }
});


}, 500);    
clearInterval(timerkk);}if( kk > 300){clearInterval(timerkk);}kk++;}, 50);
}, 1500);



var ur = window.location.href;
if(ur.includes('/ad-lan')){
  window.location.href = "/collections/nail-polish-sets"
}